export default __webpack_public_path__ + "static/media/le_mont6.1a424621.jpg";